module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Figures")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig_1_1"
    }
  }, [_vm._v("Fig. 1–1.")])]), _vm._v("Batch Processing")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#Fig_1_2"
    }
  }, [_vm._v("Fig. 1–2.")])]), _vm._v("Batch Processing Facility")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#Fig_2_1"
    }
  }, [_vm._v("Fig. 2–1.")])]), _vm._v("Oil and Gas Reservoirs")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#Fig_2_2"
    }
  }, [_vm._v("Fig. 2–2.")])]), _vm._v("Processing Oil and Gas in the Oil Patch")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_1"
    }
  }, [_vm._v("Fig. 3–1.")])]), _vm._v("Boiling Water")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_2"
    }
  }, [_vm._v("Fig. 3–2.")])]), _vm._v("Boiling Crude Oil")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_3"
    }
  }, [_vm._v("Fig. 3–3.")])]), _vm._v(" Crude Oil Distillation Curve")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_4"
    }
  }, [_vm._v("Fig. 3–4.")])]), _vm._v(" Distillation Curves of Some Crudes")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_5"
    }
  }, [_vm._v("Fig. 3–5.")])]), _vm._v(" Distillation Apparatus")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_6"
    }
  }, [_vm._v("Fig. 3–6.")])]), _vm._v("Fractions (or Cuts) from Crude Oil")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_7"
    }
  }, [_vm._v("Fig. 3–7.")])]), _vm._v("Kerosene Cut from Two Different Crudes")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_8"
    }
  }, [_vm._v("Fig. 3–8.")])]), _vm._v("API Gravities of Asphalt and Gasoline")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#Fig_3_9"
    }
  }, [_vm._v("Fig. 3–9.")])]), _vm._v("Bubble Cap Pitted by High TAN Crude")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–1.")])]), _vm._v(" Early Batch Distilling")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–2.")])]), _vm._v(" Two Stage Batch Distillation")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–4.")])]), _vm._v(" Preprocessing for the Distilling Column")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–3.")])]), _vm._v(" Crude Oil Distillation Column Schematic")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–5.")])]), _vm._v(" Liquid and Vapor Crude Oil Enters the Distillation Column")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–6.")])]), _vm._v(" Bubble Caps on a Column’s Tray")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–7.")])]), _vm._v(" Trays, Bubble Caps, and Downcomers")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–8.")])]), _vm._v(" Reflux and Reboil on a Distilling Unit")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–9.")])]), _vm._v(" Distillation Curves for Kerosene (at the top) and Naphtha")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–10.")])]), _vm._v(" Percent Volume Vaporized for Kerosene and Naphtha")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–11.")])]), _vm._v("Distilling Fractions and Their Destinations")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–12.")])]), _vm._v(" Sieve Tray")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#Fig_4_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 4–13.")])]), _vm._v(" Distilling Column Packing")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#Fig_5_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 5–1.")])]), _vm._v(" Distilling Curve Instability at High Temperatures")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#Fig_5_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 5–2.")])]), _vm._v(" Cracking Molecules")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#Fig_5_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 5–3.")])]), _vm._v("Cracked Volumes are Larger")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#Fig_5_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 5–4.")])]), _vm._v("Vacuum Flasher (Vacuum Distillation Unit) Schematic")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#Fig_5_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 5–5.")])]), _vm._v("Vacuum Flasher")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#Fig_6_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 6–1.")])]), _vm._v("Molecules")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#Fig_6_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 6–2.")])]), _vm._v(" Methane")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#Fig_6_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 6–4.")])]), _vm._v(" Propane, Normal Butane, and Pentane")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#Fig_6_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 6–3.")])]), _vm._v(" Ethane")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#Fig_6_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 6–5.")])]), _vm._v(" Isomers - Isobutane and Isopentane")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#Fig_6_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 6–6.")])]), _vm._v(" Cyclic Compounds - Cyclopentane and Cyclohexane")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#Fig_6_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 6–7.")])]), _vm._v(" Methyl Cyclopentane")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#Fig_6_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 6–8.")])]), _vm._v(" Olefins - Ethylene, Propylene, and Butylene")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#Fig_6_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 6–9.")])]), _vm._v("Aromatics - Benzene, Toluene, and Xylene")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#Fig_6_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 6–10.")])]), _vm._v("An Asphaltene")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#Fig_7_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 7–1.")])]), _vm._v("Gas Plant Compression")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#Fig_7_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 7–2.")])]), _vm._v("Rectified Absorber")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#Fig_7_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 7–3.")])]), _vm._v(" Debutanizer, Depropanizer, and Deisobutanizer")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#Fig_7_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 7–4.")])]), _vm._v(" Sponge Absorber")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#Fig_7_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 7–5.")])]), _vm._v(" Sats Gas Plant")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#Fig_7_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 7–6.")])]), _vm._v(" Rock Cavern")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#Fig_7_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 7–7.")])]), _vm._v("Salt Dome Storage Cavern")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#Fig_8_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 8–1.")])]), _vm._v("Reaction and Disengagement Section")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#Fig_8_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 8–2.")])]), _vm._v("Catalyst Regeneration Section")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#Fig_8_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 8–3.")])]), _vm._v("Cat Cracker Fractionator")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#Fig_8_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 8–4.")])]), _vm._v(" Cat Cracker Components Together")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#Fig_8_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 8–5.")])]), _vm._v(" Typical Cat Cracker")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#Fig_8_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 8–6.")])]), _vm._v(" Cat Cracker’s Place in the Refinery")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#Fig_9_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 9–1.")])]), _vm._v(" Alkylation Reactions")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#Fig_9_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 9–2.")])]), _vm._v(" Alkylation Plant Flow")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#Fig_9_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 9–3.")])]), _vm._v(" Alky Plant Reactors")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#Fig_9_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 9–4.")])]), _vm._v(" Alkylation Place in the Refinery")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#Fig_10_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 10–1.")])]), _vm._v(" Reactions in a Cat Reformer")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#Fig_10_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 10–2.")])]), _vm._v(" Semi-continuous Cat Reformer Flows")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#Fig_10_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 10–3.")])]), _vm._v(" Continuous Cat Reformer Flows")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#Fig_10_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 10–4.")])]), _vm._v(" Continuous Cat Reformer")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#Fig_10_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 10–5.")])]), _vm._v(" Yields versus Octane Number")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#Fig_11_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 11–1.")])]), _vm._v(" Hydrocracker")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#Fig_11_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 11–2.")])]), _vm._v(" H-Oil Reactor")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#Fig_12_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 12–1.")])]), _vm._v(" Butane Isomerization Plant")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#Fig_12_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 12–2.")])]), _vm._v("C5/C6 Isomerization Plant")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap13#Fig_13_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 13–1.")])]), _vm._v("Thermal Cracker")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap13#Fig_13_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 13–2.")])]), _vm._v("Delayed Coker")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap13#Fig_13_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 13–3.")])]), _vm._v("Fluid Coker")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap13#Fig_13_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 13–4.")])]), _vm._v(" Flexicoker with a Coke Gasifier")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap13#Fig_13_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 13–5.")])]), _vm._v(" Conversion Plant Yields of Light Oils")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#Fig_14_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 14–1.")])]), _vm._v("Four Stroke Internal Combustion Engine")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#Fig_14_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 14–2.")])]), _vm._v("Compression Ratio V1 over V2")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#Fig_14_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 14–3.")])]), _vm._v("Octane Determination Procedure")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#Fig_14_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 14–4.")])]), _vm._v("(R+M)/2 on a Gasoline Dispenser")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#Fig_14_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 14–5.")])]), _vm._v(" Impact of Lead on Octane Numbers")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#Fig_14_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 14–6.")])]), _vm._v(" Meeting Environmental Requirements")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap15#Fig_15_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 15–1.")])]), _vm._v(" Flash Point Danger")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap15#Fig_15_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 15–2.")])]), _vm._v(" Two Stroke Diesel Engine")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#Fig_16_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 16–1.")])]), _vm._v(" Thiophene")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#Fig_16_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 16–2.")])]), _vm._v(" Hydrotreater")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#Fig_16_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 16–3.")])]), _vm._v(" Smoke Point Testing Apparatus")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#Fig_16_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 16–4.")])]), _vm._v(" Steam Methane Reformer Hydrogen Plant")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#Fig_16_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 16–5.")])]), _vm._v(" Hydrogen Sulfide Extraction")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap16#Fig_16_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 16–6.")])]), _vm._v(" Sulfur Recovery Plant")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap17#Fig_17_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 17–1.")])]), _vm._v(" An Asphaltene")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap17#Fig_17_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 17–2.")])]), _vm._v("Asphalt Processing Schemes")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#Fig_18_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 18–1.")])]), _vm._v("Flow Rates and Different Viscosities")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#Fig_18_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 18–2.")])]), _vm._v("Lubricants Processing")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#Fig_18_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 18–3.")])]), _vm._v("Choosing the Right Lubricant")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap19#Fig_19_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 19–1.")])]), _vm._v("Ethane - Propane Cracker Schematic")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap19#Fig_19_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 19–2.")])]), _vm._v("Ethane Cracker")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap19#Fig_19_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 19–3.")])]), _vm._v(" Naphtha - Gas Oil Cracker Schematic")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap19#Fig_19_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 19–4.")])]), _vm._v("Naphtha - Gas Oil Cracker")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap19#Fig_19_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 19–5.")])]), _vm._v(" Butadiene")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap19#Fig_19_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 19–6.")])]), _vm._v(" Solvent Extraction")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap19#Fig_19_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 19–7.")])]), _vm._v(" Solvent Recovery of Aromatics")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap19#Fig_19_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 19–8.")])]), _vm._v(" Refinery - Olefin Plant Exchanges")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap20#Fig_20_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 20–1.")])]), _vm._v(" Simple Refinery")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap20#Fig_20_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 20–2.")])]), _vm._v(" Complex Refinery")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap20#Fig_20_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 20–3.")])]), _vm._v(" Very Complex Refinery")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap20#Fig_20_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 20–4.")])]), _vm._v(" Marginal Refinery Yields vs Capacity Utilization")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap20#Fig_20_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 20–5.")])]), _vm._v(" Linear Program Inputs and Outputs")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap20#Fig_20_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 20–6.")])]), _vm._v(" Refinery Linear Programming Matrix")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap20#Fig_20_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 20–7.")])]), _vm._v(" Linear Programming Solution")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap21#Fig_21_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 21–1.")])]), _vm._v(" Benchmarks of Refinery Throughput Costs")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap21#Fig_21_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 21–2.")])]), _vm._v(" Assessing the Performance Gap")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap21#Fig_21_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 21–3.")])]), _vm._v("Closing the Gap - an Example")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap21#Fig_21_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 21–5.")])]), _vm._v("Comparing Complexities")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap21#Fig_21_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 21–4.")])]), _vm._v("Complexity Factor Calculation")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap21#Fig_21_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 21–6.")])]), _vm._v("Benchmarks Based on Complexities")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap22#Fig_22_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 22–1.")])]), _vm._v(" Fuel Value Nomogram")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap22#Fig_22_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 22–2.")])]), _vm._v("Recent High and Low Prices")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen5#Fig_23_7_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23–7–1.")])]), _vm._v("Columns to Segregate Cracked C4s")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen5#Fig_23_10_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23–10–7.")])]), _vm._v("Normal Hexane to Cyclohexane")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen5#Fig_23_10_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23–10–11.")])]), _vm._v("CRU Added to the Refinery")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen5#Fig_23_6_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23–6–1.")])]), _vm._v("Isobutane")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen5#Fig_23_6_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23–6–2.")])]), _vm._v("Pentane Isomers")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen5#Fig_23_6_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23–6–3.")])]), _vm._v("Isobutylene")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen5#Fig_23_6_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23–6–4.")])]), _vm._v("Xylene Isomers")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen5#Fig_23_10_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23–10–6.")])]), _vm._v("Normal Paraffins to Isoparaffins")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen5#Fig_23_10_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23–10–8.")])]), _vm._v("Cyclohexane to Benzene")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen5#Fig_23_10_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23–10–9.")])]), _vm._v("Cyclohexane to Normal Butane and Methane")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('b', [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen5#Fig_23_10_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig. 23–10–10")]), _vm._v(". ")]), _vm._v("Side Chains Crack off Cyclics Methane")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0